import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  CONTENT_DATES,
  getContentDateLabels,
} from '../../seo/contentMetadata';

const formatDate = (date, locale) => {
  const parsedDate = new Date(`${date}T00:00:00Z`);

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(parsedDate);
};

const ContentDate = () => {
  const { language } = useLanguage();
  const labels = getContentDateLabels(language);
  const publishedDate = formatDate(
    CONTENT_DATES.published,
    labels.locale,
  );
  const updatedDate = formatDate(
    CONTENT_DATES.updated,
    labels.locale,
  );
  const accessibleLabel = [
    `${labels.published} ${publishedDate}`,
    `${labels.updated} ${updatedDate}`,
  ].join(` ${labels.separator} `);

  return (
    <p
      className="content-date"
      role="doc-dateline"
      aria-label={accessibleLabel}
      data-published={CONTENT_DATES.published}
      data-updated={CONTENT_DATES.updated}
    >
      <span>{labels.published}{labels.punctuation}</span>
      <time
        dateTime={CONTENT_DATES.published}
        itemProp="datePublished"
      >
        {publishedDate}
      </time>
      <span aria-hidden="true"> · </span>
      <span>{labels.updated}{labels.punctuation}</span>
      <time
        dateTime={CONTENT_DATES.updated}
        itemProp="dateModified"
      >
        {updatedDate}
      </time>
    </p>
  );
};

export default ContentDate;